const isValidEmail = (email) => {
    return /^[a-zA-Z0-9._-]+@[^.\s@!#$%^&*()\-+?/|][a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,4}$/.test(email);
}

export default isValidEmail;